<template>
    <div>
        <template v-if="crud_branches === true">
            <div class="container">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left">Add Branch</h1>
                </div>
                <div class="global-main">
                    <form id="cityForm" @submit.prevent="addBranchData">
                        <div class="tab-content-inner">
                            <div class="form-group">
                                <label> Name </label>
                                <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                <has-error :form="form" field="name"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                            <router-link to="/branches" class="btn btn-primary float-right mr-2">Cancel</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-if="crud_branches === null"><preLoader></preLoader></template>
        <template v-if="crud_branches === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                }),
                crud_branches : null,
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_branches').then(result=>{
                this.crud_branches = result.crud_branches;
                this.$Progress.finish();
            });
        },
        methods: {
            addBranchData() {
                this.$Progress.start();
                this.form.post('api/addBranch')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Branch created successfully'
                        });
                        this.$router.push('/branches');
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            }
        },
        created() {
            //
        },
    }
</script>
